import React from 'react';

const ActionItem = ({currentAction, setCurrentAction, item, handleChange}) => {
    return (
            <div 
            className={`choose_action_item ${currentAction === item?.name ? `choose_action_item_${item.className}` : '' }`}
            onClick={() => { setCurrentAction(item.name); handleChange(item.name)}}
            >
                <img src={`/img/action/${item.img}`} alt="" />
                <p className={`choose_action_item_name ${currentAction === item.name ? 'choose_action_item_name_active' : '' }`}>{item.name}</p>
            </div>
    );
};

export default ActionItem;